import { VIEWER_SET_SHOW_SLICE_VIEWS } from '../actions';

export default function setShowSliceViews(showSliceViews) {
  return {
    type: VIEWER_SET_SHOW_SLICE_VIEWS,
    showSliceViews,
  };
}
